import { Injectable, ErrorHandler } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { IApiResponse } from '../models';
import { ICouponDto, IValidateCouponDto } from '../models/coupon.model';

@Injectable()
export class CouponService extends ApiService {
  constructor(http: HttpClient, errorHandler: ErrorHandler) {
    super(http, errorHandler);
  }

  public getCouponList(id: number, modeId: number): Observable<ICouponDto[]> {
    return this.get(`coupon/${id}/${modeId}`);
  }

  public validateCoupon(
    model: IValidateCouponDto,
  ): Observable<IApiResponse<ICouponDto>> {
    return this.post(`coupon`, model);
  }
}
